import getDimensionsMinimalRatio from './getDimensionsMinimalRatio';

/**
 * Scale factor for fitting the original image inside the canvas container.
 * Returns 1 when the image is not loaded yet (canvas size may arrive first).
 */
const computeCanvasScale = (state, canvasWidth, canvasHeight) => {
  const { initialCanvasWidth, initialCanvasHeight, originalImage } = state;

  if (
    !canvasWidth ||
    !canvasHeight ||
    !originalImage?.width ||
    !originalImage?.height
  ) {
    return 1;
  }

  const initialCanvasW = initialCanvasWidth ?? canvasWidth;
  const initialCanvasH = initialCanvasHeight ?? canvasHeight;

  const originalImageInitialScale = getDimensionsMinimalRatio(
    initialCanvasW,
    initialCanvasH,
    originalImage.width,
    originalImage.height,
  );
  const originalImageInitialResizedWidth =
    originalImageInitialScale * originalImage.width;
  const originalImageInitialResizedHeight =
    originalImageInitialScale * originalImage.height;

  if (
    initialCanvasW === canvasWidth &&
    initialCanvasH === canvasHeight
  ) {
    return 1;
  }

  const widthScale = canvasWidth / originalImageInitialResizedWidth;
  const heightScale = canvasHeight / originalImageInitialResizedHeight;
  const scale = Math.min(widthScale, heightScale);

  return Number.isFinite(scale) && scale > 0 ? scale : 1;
};

export default computeCanvasScale;
